import { Row } from "../components/Layout";
import React from "react";
import Orders from "./orders";
import { useUserInfo } from "../common/user-context";

const OrderManagement = (props) => {

  const {userData} = useUserInfo();

  return (
    <div className="container-fluid min-h-[350px]">
      <div className="container-fluid min-h-[350px]">
        <div className="p-[8px] pl-[15px]">
          <Row className="border-2 border-gray-300 rounded-md">
            <Orders></Orders>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default OrderManagement;
